export class UserResponse {
  email!: string;
  userUuid!: string;
  enabled!: boolean;
  lastLoginTime?: string;
  lastLoginChallanges?: string;
}
